import React, { useEffect, useState } from 'react';
import { FlowService } from '../../service/FlowService';
import { Box, Typography } from '@mui/material';
import {
  NotificationType,
  useNotificationStore,
} from '../../store/storeNotifications';
import { getAPIErrorMessage } from '../../helpers/helpers';
import LoadingSpinner from '../../components/UI/LoadingSpinner';
import FlowsTable from './FlowsTable';

const SharedFlows: React.FC = () => {
  const setNotification = useNotificationStore(state => state.setNotification);
  const [sharedFlows, setSharedFlows] = useState<any[]>([]);
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getSharedFlows = async () => {
      try {
        const { data } = await FlowService.getSharedFlows(page);
        setSharedFlows(data[0]);
      } catch (error) {
        setNotification({
          type: NotificationType.Error,
          message: getAPIErrorMessage(error as any),
        });
      }
      setLoading(false);
    };

    getSharedFlows();
  }, [page]);

  if (loading) return <LoadingSpinner />;

  if (!loading && sharedFlows.length === 0)
    return (
      <Box
        sx={{
          border: '1px dashed rgba(208, 213, 221, 1)',
          width: '450px',
          height: '225px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            color: 'rgba(71, 84, 103, 1)',
          }}
        >
          You don’t have any shared agents
        </Typography>
      </Box>
    );

  return <FlowsTable flows={sharedFlows} />;
};

export default SharedFlows;
